import { Schema as S } from "effect";

import { apiData } from "../../api/asyncData";
import { RateCardHistory } from "../../api/schemas/ledger";

export const Model = S.Struct({
	page: S.Literal("RateCard"),
	history: apiData(RateCardHistory).schema,
});
export type Model = typeof Model.Type;
